import { render, staticRenderFns } from "./Brands.vue?vue&type=template&id=48bb2ed5"
import script from "./Brands.vue?vue&type=script&lang=js"
export * from "./Brands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsLink: require('/opt/build/repo/components/Elements/Link.vue').default,ElementsButton: require('/opt/build/repo/components/Elements/Button.vue').default,ElementsSlider: require('/opt/build/repo/components/Elements/Slider.vue').default})
